// HospitalPage.js
import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import StickyHeader from "../../components/StickyHeader";
import StickyFooter from "../../components/StickyFooter";
import "../../css/EnergyManageSystem.css";

function EnergyManageSystem() {
  useEffect(() => {
    AOS.init({
      duration: 800, // 缩短动画时间使响应更快
      once: false, // 允许重复触发动画
      offset: 100,
      easing: "ease-out-cubic", // 添加缓动效果
      delay: 0,
      mirror: true, // 页面滚动时反向动画
    });
  }, []);
  return (
    <div className="home-container">
      <StickyHeader />
      <div className="main-content">
        <div
          className='stitle'
        >
          <img
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            src={`${process.env.PUBLIC_URL}/imgs/ems-banner.png`}
            alt=""
          />
          <div className="top-title-ems">实 时 数 据 监 测&nbsp;&nbsp;&nbsp;&nbsp;能 量 平 衡 控 制</div>
          <div className="top-title-ems-2">
            <img src={`${process.env.PUBLIC_URL}/imgs/更可靠.png`} alt="" /><span>更可靠</span>
            <img src={`${process.env.PUBLIC_URL}/imgs/更高效.png`} alt="" /><span>更高效</span>
            <img src={`${process.env.PUBLIC_URL}/imgs/更专业.png`} alt="" /><span>更专业</span>
          </div>
        </div>
        <div style={{ minHeight: "800px" }}>
          {/* 第一个盒子 - 产 品 介 绍 */}
          <div className="top1 animated-section">
            <Container>
              <div className="box">
                <div className="top">
                  <div className="noe1" data-aos="fade-down">
                    <span className="h1">产 品 介 绍</span>
                    <p>
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/Dot.png`}
                        alt=""
                        className="dot-animation"
                      />
                    </p>
                  </div>
                  <div className="boxno">
                    <div
                      className="rit"
                      data-aos="fade-right"
                      data-aos-delay="200"
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/ems柜体.png`}
                        alt=""
                        className="image-hover"
                      />
                    </div>
                    <div className="lef" data-aos="fade-left">
                      <h3 className="h3name">
                        虚拟电厂调度软件V1.0(Nwa-SAAS-F)
                      </h3>
                      <div className="line"></div>
                      <span className="textnoe">
                        是专为工商业储能液冷/风冷一体柜开发的配套软件，应用在工商业储能中的单柜部署和多柜组网两个场景中作为
                        EMS 使用，采用四核 64 位Cortex-A55 架构，主频
                        1.8GHZ，集成 Rockchip 自研 NPU， 1TOPS
                        算力，满足轻量级端侧 AI 计算。内存最高支持
                        4GB,存储最高支持 32GB
                        eMMC。EMS具有广泛的硬件外设支持，包括
                        RS485、RS232、CAN、USB、以太网口、4G、WiFi、DI、DO、mSATA、HDMI
                        等功能接口和模块。{" "}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>

          {/* 第二个盒子 - 产品优势 */}
          <div className="top2 block-section" style={{ height: "887px" }}>
            <Container>
              <div className="box">
                <div className="top">
                  <div className="noe1" data-aos="fade-down">
                    <span className="h2" style={{ color: "#000" }}>
                      产 品 优 势
                    </span>
                    <p>
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/Dot.png`}
                        alt=""
                        className="dot-animation"
                      />
                    </p>
                  </div>
                  <div className="boxno">
                    {[
                      {
                        img: "ems峰谷套利.png",
                        title: "峰谷套利",
                      },
                      {
                        img: "ems需量管理.png",
                        title: "需量管理",
                      },
                      {
                        img: "ems调频调压.png",
                        title: "AGC/AVC一次调频/调压",
                      },
                      {
                        img: "ems应急备电.png",
                        title: "应急备电",
                      },
                      {
                        img: "ems消纳绿电.png",
                        title: "消纳绿电",
                      },
                      {
                        img: "ems需求侧响应.png",
                        title: "需求侧响应",
                      },
                      {
                        img: "ems优化供电质量.png",
                        title: "优化供电质量",
                      },
                      {
                        img: "ems末端电压治理.png",
                        title: "末端电压治理",
                      },
                    ].map((item, index) => (
                      <div
                        key={index}
                        className="boxflex boxflex-center"
                        data-aos="fade-up"
                        data-aos-delay={index * 200}
                      >
                        <div className="flextop">
                          <img
                            src={`${process.env.PUBLIC_URL}/imgs/${item.img}`}
                            alt=""
                          />
                        </div>
                        <div className="flexbut flextextsp">
                          <p>{item.title}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Container>
          </div>

          {/* 第三个盒子 - 产品参数 */}
          <div className="top2 block3-section" style={{ height: "887px" }}>
            <Container>
              <div className="box">
                <div className="top">
                  <div className="noe1" data-aos="fade-down">
                    <span className="h2" style={{ color: "#000" }}>
                      产 品 参 数
                    </span>
                    <p>
                      <img
                        src={`${process.env.PUBLIC_URL}/imgs/Dot.png`}
                        alt=""
                        className="dot-animation"
                      />
                    </p>
                  </div>
                  <div className="boxno ">
                    {[
                      {
                        img: "ems系统参数.png",
                        title: "系统参数",
                        desc: "CPU瑞芯微 RK3568J 四核，RAM4GB，ROM32GB",
                      },
                      {
                        img: "ems通讯方式.png",
                        title: "通讯方式",
                        desc: "CAN /RS485/ RS232/DO/DI/ Ethernet",
                      },
                      {
                        img: "ems联网方式.png",
                        title: "联网方式",
                        desc: "4G/ Internet",
                      },
                      {
                        img: "ems工作环境.png",
                        title: "工作环境",
                        desc: "湿度：5％～95％，无凝露",
                      },
                      {
                        img: "ems工作温度.png",
                        title: "工作温度",
                        desc: "-40℃~+75℃",
                      },
                      {
                        img: "ems尺寸.png",
                        title: "尺寸（含挂耳）",
                        desc: "214mm*140mm*45mm(长*宽*高)",
                      },
                    ].map((item, index) => (
                      <div
                        key={index}
                        className="boxflex boxflex-center"
                        style={{ "flex-basis": `calc(33% - 20px)` }}
                        data-aos="fade-up"
                        data-aos-delay={index * 200}
                      >
                        <div className="flextop" style={{marginBottom: "0"}}>
                          <img
                            src={`${process.env.PUBLIC_URL}/imgs/${item.img}`}
                            alt=""
                          />
                        </div>
                        <div className="flexbut" style={{paddingTop: "0"}}>
                          <p style={{ color: "#000" }}>{item.title}</p>
                          <p style={{ color: "#757575" }}>{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </div>
      </div>

      <StickyFooter />
    </div>
  );
}

export default EnergyManageSystem;
